import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import "./index.css";

import SignUp from './allUserspage/Signup';
import Login from './allUserspage/Login';
import AllRendering from './Homepages&comp/AllRendering';
import JobSeekersDashboard from './allUserspage/JobSeekersDashboard';
import RecruitersDashboard from './allUserspage/RecruitersDashboard';
import JobEditPage from './allUserspage/JobEditPage';
import Apply from './allUserspage/Apply';
import PrivateRoute from './PrivateRoute';

export default function App() {
  return (
    <div className='bg-zinc-900'>
      <Routes>
        <Route path="/" element={<AllRendering />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/login" element={<Login />} />
        <Route
            path="/dashboard/job_seeker"
            element={
              <PrivateRoute>
                <JobSeekersDashboard />
               </PrivateRoute> 
            }
          />
          <Route
            path="/dashboard/recruiter" 
            element={
              <PrivateRoute>
                <RecruitersDashboard />
               </PrivateRoute> 
            }
          />
        <Route path="/edit-job/:jobId" element={<JobEditPage />} />
        <Route path="/appply" element={<Apply/>} />
        <Route path="*" element={<Navigate to="/" />} /> {/* Redirect unknown paths */}
      </Routes>
    </div>
  );
}